import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useHeading } from '../context/HeadingContext';
import { useDispatch, useSelector } from 'react-redux';
import { showAddButton } from '../redux/slices/Product/showAddProductButton';
import { UpdateDayTerm } from '../redux/slices/Filters/DaySlice';

const Headings = ({ }) => {
    const { heading: contextHeading } = useHeading();

    const tab = useSelector((state) => state.activeTab.tab)
    const dayTerm = useSelector((state) => state.day.term);
    const dispatch = useDispatch();

    const location = useLocation();
    const navigate = useNavigate();

    let heading;
    switch (location.pathname) {
        case '/admin-dashboard':
            heading = "Dashboard";
            break;
        case '/admin-dashboard/menu-management':
            heading = "Menu Management";
            break;
        case '/admin-dashboard/customer-management':
            heading = "Customer's Management";
            break;
        case '/admin-dashboard/suppliers-management':
            heading = "Supplier's Management";
            break;
        case '/admin-dashboard/restaurants-management':
            heading = "Restaurants Management";
            break;
        case '/admin-dashboard/product-management':
            heading = 'Product Management';
            break;
        case '/admin-dashboard/order-management':
            heading = "Orders Management";
            break;
        case '/admin-dashboard/news-and-events-management':
            heading = "News and Events Management";
            break;
        case '/admin-dashboard/content-management':
            heading = "Content Management";
            break;
        case '/admin-dashboard/queries-management':
            heading = "Queries Management";
            break;
        case '/admin-dashboard/cart':
            heading = "Admin";
        // case '/admin-dashboard/order-detail/restaurant':
        //     heading = 'Restaurant'
        // case '/admin-dashboard/supplier-detail':
        //     heading = contextHeading || "Supplier's Details";
        //     break;
        //     break;
        default:
            heading = location.pathname.includes('/admin-dashboard/order-detail/restaurant')
                ? 'Restaurant'
                : location.pathname.includes('/supplier-detail')
                    ? (contextHeading || "Supplier's Details")
                    : location.pathname.includes('/detail') ? (contextHeading || '') : 'Admin';
    }

    const handleAddNewClick = () => {
        if (location.pathname === '/admin-dashboard/product-management') {

            navigate('/admin-dashboard/add-product')
        }
        if (location.pathname === '/admin-dashboard/news-and-events-management') {

            navigate('/admin-dashboard/add-news-and-events')
        }
        if (location.pathname === '/admin-dashboard/menu-management') {

            navigate('/admin-dashboard/add-menu')
        }
    }

    useEffect(() => {
        // Reset the dayTerm filter whenever the route changes
        dispatch(UpdateDayTerm(""));
    }, [location.pathname, dispatch]);
    return (
        <section className='heading_section'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='hstack justify-content-between align-items-end flex-wrap gap-3'>
                            <div className='main_heading'>
                                <h1>
                                    <span className='welcome_text fs-5 mb-2'>Welcome back,</span>
                                    <span className='main_title fs-2'>{`${heading}`}</span>
                                </h1>
                            </div>

                            {(location.pathname === '/admin-dashboard/menu-management' || location.pathname === '/admin-dashboard/product-management' || location.pathname === '/admin-dashboard/news-and-events-management' || location.pathname === '/admin-dashboard/suppliers-management' || location.pathname === '/admin-dashboard/content-management' && (tab == 'categories' || tab == 'foodCategories' || tab == 'productTypes' || tab === 'units')) && (
                                // <div className='d-flex flex-end flex-wrap gap-2'>
                                //     <button className='primary-btn py-2' onClick={handleAddNewClick}
                                //         {
                                //         ...(location.pathname === '/admin-dashboard/content-management'
                                //             ? tab === 'categories'
                                //                 ? {
                                //                     'data-bs-toggle': 'modal',
                                //                     'data-bs-target': '#addCategoryModal',
                                //                 }
                                //                 : tab === 'foodCategories'
                                //                     ? {
                                //                         'data-bs-toggle': 'modal',
                                //                         'data-bs-target': '#addFoodCategoryModal',
                                //                     }
                                //                 : tab === 'productTypes'
                                //                     ? {
                                //                         'data-bs-toggle': 'modal',
                                //                         'data-bs-target': '#addProductTypeModal',
                                //                     }
                                //                     : tab === 'units' ? {
                                //                         'data-bs-toggle': 'modal',
                                //                         'data-bs-target': '#addUnitsModal',
                                //                     } : {}
                                //             : {})
                                //         }>+ Add New</button>
                                // </div>
                                <div className='d-flex flex-end flex-wrap gap-2'>
                                    {location.pathname === '/admin-dashboard/menu-management' && (
                                        <select
                                            className="form-select"
                                            style={{ width: '200px' }}
                                            value={dayTerm}
                                            onChange={(e) => {
                                                dispatch(UpdateDayTerm(e.target.value));
                                            }}
                                        >
                                            <option value="">All Days</option>
                                            <option value="0">Monday</option>
                                            <option value="1">Tuesday</option>
                                            <option value="2">Wednesday</option>
                                            <option value="3">Thursday</option>
                                            <option value="4">Friday</option>
                                            <option value="5">Saturday</option>
                                            <option value="6">Sunday</option>
                                        </select>
                                    )}

                                    <button
                                        className='primary-btn py-2'
                                        onClick={handleAddNewClick}
                                        {...(
                                            location.pathname === '/admin-dashboard/content-management'
                                                ? tab === 'categories'
                                                    ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#addCategoryModal' }
                                                    : tab === 'foodCategories'
                                                        ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#addFoodCategoryModal' }
                                                        : tab === 'productTypes'
                                                            ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#addProductTypeModal' }
                                                            : tab === 'units'
                                                                ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#addUnitsModal' }
                                                                : {}
                                                : location.pathname === '/admin-dashboard/suppliers-management'
                                                    ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#addSupplierModal' }
                                                    : {}
                                        )}
                                    >
                                        + Add New
                                    </button>
                                </div>

                            )}

                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Headings;